// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: HPActionDetails
// ====================================================

export interface HPActionDetails {
  /**
   * Whether the user wants to sue for repairs.
   */
  sueForRepairs: boolean | null;
  /**
   * Whether the user wants to sue for harassment.
   */
  sueForHarassment: boolean | null;
  /**
   * Whether the user has filed any complaints with 311 before.
   */
  filedWith311: boolean | null;
  /**
   * Whether 30 days have passed since the user filed complaints with 311.
   */
  thirtyDaysSince311: boolean | null;
  /**
   * Whether HPD issued any violations.
   */
  hpdIssuedViolations: boolean | null;
  /**
   * Whether 30 days have passed since HPD issued violations.
   */
  thirtyDaysSinceViolations: boolean | null;
  /**
   * Whether the conditions are urgent and dangerous.
   */
  urgentAndDangerous: boolean | null;
}

export const BlankHPActionDetails: HPActionDetails = {
  "sueForRepairs": null,
  "sueForHarassment": null,
  "filedWith311": null,
  "thirtyDaysSince311": null,
  "hpdIssuedViolations": null,
  "thirtyDaysSinceViolations": null,
  "urgentAndDangerous": null
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment HPActionDetails on HPActionDetailsType {
  sueForRepairs,
  sueForHarassment,
  filedWith311,
  thirtyDaysSince311,
  hpdIssuedViolations,
  thirtyDaysSinceViolations,
  urgentAndDangerous
}`;